import React, { useContext, useEffect } from 'react';

import axios from 'axios';
import ReactQuill from 'react-quill';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { CircularProgress } from '@mui/material';
import { styled as materialStyled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

import { BodyBlock, ContentBlock } from '.';

import copyIcon from '../../../assets/img/copyIcon.svg';
import dragHandle from '../../../assets/img/dragIcon.svg';
import editIcon from '../../../assets/img/editImg.svg';
import { SnackBarContext } from '../../../context/snackBarContext';
import { UpdateOptionContext } from '../../../context/updateOptionContext';
import useDebounce from '../../../hooks/useDebounce';
import useOutsideClick from '../../../hooks/useOutsideClick';
import { API_URLS, APPLICATION_HEADERS } from '../../../models/headers';
import * as actionTypes from '../../../store/actions/index';
import HeartIcon from '../../Core/CustomIcons/HeartIcon';

const TableOption = ({ option, surveyID, shortlistedOptions, provided, snapshot }) => {
  const dispatch = useDispatch();

  const [isOptionShowedInClientDeliverable, setIsOptionShowedInClientDeliverable] = React.useState(
    option.includeOnClientDeliverable,
  );
  const [isOptionShowedMounted, setIsOptionShowedMounted] = React.useState(false);

  const notesFieldRef = React.useRef(null);

  const [isEditableFieldsOpened, setIsEditableFieldsOpened] = React.useState({
    notes: false,
  });

  const [isEditableNotes, setIsEditableNotes] = React.useState(false);

  const [isCopyOptionLoading, setIsCopyOptionLoading] = React.useState(false);

  const [optionData, setOptionData] = React.useState({
    optionName: option.optionName || '-',
    address: option?.address || '-',
    optionOrder: option?.optionOrder || '',
    providerName: option?.providerName || '-',
    notes: option?.notes || '',
  });

  const debouncedOptionShowed = useDebounce(isOptionShowedInClientDeliverable, 300);
  const debouncedNotes = useDebounce(optionData.notes, 500);

  // const { setSnackBars } = useContext(SnackBarContext);

  const handleUpdateOption = (
    reqObj,
    surveyID,
    { onSuccess, onFail, onFinally } = MOCKED_RESULT_FUNCTIONS,
  ) => {
    // setIsCopyOptionLoading(true);
    dispatch(
      updateOption(reqObj, surveyID, {
        onSuccess: () => {
          setIsCopyOptionLoading(false);
          // setSnackBars({
          //   fail: false,
          //   success: true,
          //   title: 'Successfully updated',
          // });
          onSuccess?.();
        },
        onFail: () => {
          setIsCopyOptionLoading(false);
          // setSnackBars({
          //   fail: true,
          //   success: false,
          //   title: 'Something went wrong',
          // });
          onFail?.();
        },
        onFinally: () => {
          setIsCopyOptionLoading(false);
          onFinally?.();
        },
      }),
    );
  };
  const handleChangeNotes = (e) => {
    setIsEditableNotes(true);
    setOptionData((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const handleChangeOptionData = (value) => {
    setIsEditableNotes(true);
    setOptionData((prev) => ({
      ...prev,
      notes: value,
    }));
    setIsCopyOptionLoading(false);
  };

  const handleControlFields = (name, boolean) => {
    // setIsEditableFieldsOpened((prev) => ({
    //   ...prev,
    //   [name]: boolean,
    // }));
    setIsEditableNotes(true);
  };

  useOutsideClick(notesFieldRef, () => {
    isEditableFieldsOpened.optionName && handleControlFields('notes', false);
    // setIsEditableFieldsOpened({ notes: false });
    setIsEditableNotes(false);
  });

  const createReqObjectAndUpdate = ({ key, value }) => {
    const reqObj = {
      id: option.id,
      [key]: value,
    };

    handleUpdateOption(reqObj, surveyID);
  };

  useEffect(() => {
    if (debouncedNotes === option.notes) return;

    createReqObjectAndUpdate({
      key: 'notes',
      value: debouncedNotes,
    });
  }, [debouncedNotes]);
  useEffect(() => {
    if (!isOptionShowedMounted) {
      setIsOptionShowedMounted(true);

      return;
    }

    const reqObj = {
      id: option.id,
      includeOnClientDeliverable: isOptionShowedInClientDeliverable ? true : false,
    };

    handleUpdateOption(reqObj, surveyID);
  }, [debouncedOptionShowed]);

  const processContent = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');

    doc.querySelectorAll('p').forEach((p) => {
      // Check if the <p> tag contains only a <br> tag
      if (p.innerHTML.trim() === '<br>') {
        p.classList.add('empty-paragraph');
      }
    });

    return doc.body.innerHTML;
  };

  return (
    <UpdateOptionContext.Provider value={{ handleUpdateOption }}>
      <ContentBlock
        ref={provided.innerRef}
        {...provided.draggableProps}
        // className={snapshot.isDragging}
      >
        <BodyBlock align="center" {...provided.dragHandleProps}>
          <img src={dragHandle} alt=".." />
        </BodyBlock>
        <BodyBlock align="center">
          <CustomSwitch
            checked={isOptionShowedInClientDeliverable}
            onChange={() => setIsOptionShowedInClientDeliverable((prev) => !prev)}
          />
        </BodyBlock>
        <BodyBlock align="right">
          {/* {shortlistedOptions.includes(option.id) && <HeartIcon color="#FF543E" />} {'  '} */}
          {optionData.optionOrder}
        </BodyBlock>
        <BodyBlock>{optionData.providerName}</BodyBlock>
        <BodyBlock>
          {optionData.address}

          {optionData?.address?.length > 0 &&
            optionData.address != '-' &&
            option?.availableSpaceList?.map((avail) => (
              <div key={avail && avail.areaMeasurement}>
                Unit {avail && avail.unit} {avail && avail.officeType}, A{' '}
                {avail && avail.productType} with {avail && avail.capacity} desks
                {avail && avail.floor > 0 ? ', Floor #' + avail.floor : ''}
                {avail && avail.area ? ', Area ' + avail.area + ' ' : ''}
                {avail && avail.area && avail?.areaMeasurement ? avail.areaMeasurement : ''}
              </div>
            ))}
        </BodyBlock>
        <BodyBlock ref={notesFieldRef} onClick={() => handleControlFields('notes', true)}>
          <div className="notes-container">
            <div className="notes-block">
              {isEditableNotes ? (
                <div style={{ display: 'inline-flex', gap: '20px', backgroundColor: '#fff' }}>
                  <ReactQuillContainer>
                    <ReactQuill
                      theme="snow"
                      id="notes"
                      value={optionData?.notes}
                      preserveWhitespace
                      modules={{
                        clipboard: {
                          matchVisual: false,
                        },
                      }}
                      className="React_quill_wrapper"
                      onChange={handleChangeOptionData}
                    />
                  </ReactQuillContainer>
                </div>
              ) : (
                <span dangerouslySetInnerHTML={{ __html: processContent(optionData?.notes) }} />
              )}
            </div>
            <div className="flex-child green">
              {!isEditableNotes && (
                <img src={editIcon} onClick={handleControlFields} alt="edit icon" />
              )}
            </div>
          </div>
        </BodyBlock>
        <BodyBlock></BodyBlock>
      </ContentBlock>
    </UpdateOptionContext.Provider>
  );
};

const StatusImage = styled.img`
  width: 16px;
  height: 20px;
  cursor: pointer;
`;

const ReactQuillContainer = styled.div`
  .React_quill_wrapper {
    height: calc(100% - 17px);
    pre {
      height: calc(100% - 26px);
    }
  }
`;

const ResponseIcon = styled.img`
  margin-right: 5px;
`;
const Column = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  // min-width: 180px;
  word-break: break-word;
  margin-right: 50px;
`;

const Input = styled.input`
  outline: none;
  border: none;
  width: 100%;
  height: 40px;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #1a1a1a;
  background: transparent;
  width: 350px;
`;

const TextArea = styled.textarea`
  box-sizing: border-box;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  border: 1px solid rgba(26, 26, 26, 0.6);
  border-radius: 4px;
  margin-top: 16px;
  resize: none;
  width: 350px;
  padding: 8px 12px;
`;

export const MOCKED_RESULT_FUNCTIONS = {
  onSuccess: () => {},
  onFail: () => {},
  onFinally: () => {},
};

export const updateOption =
  (options, surveyId, { onSuccess, onFail, onFinally }) =>
  async (dispatch) => {
    const url = `${API_URLS.updateBubbleOptionURL}`;

    const requestObject = {
      list: [options],
    };

    try {
      const response = await axios.put(url, requestObject, {
        headers: APPLICATION_HEADERS.dealHeaders,
      });

      dispatch(actionTypes.providerAction(surveyId, false, true));
    } catch (e) {
      console.error('Occured error while trying to update option, error - ', e);

      onFail && onFail();
      onFinally && onFinally();
    }
  };

export const CustomSwitch = materialStyled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#003F2D',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#003F2D',
  },
});

export default React.memo(TableOption);
